module.exports = __webpack_public_path__ + "static/media/icon-cwb-logo-grey.7d651022.svg";